<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <ListingComponent ref="approveTaskList"
                      class="bg-white"
                      :addNewButton="addNewButton"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
  </div>
</template>

<script>
import ListingComponent from '@/components/listing/ListingComponent'
import moment from 'moment'
export default {
  name: 'DegreeListPage',
  data () {
    return {
      id: null,
      isDeleteModal: false,
      columnConfig: [
        {
          columnCode: 'action',
          columnName: 'Action',
          value: (item) => {
            return (
              <b-dropdown variant="link" class="listing-action">
                <b-dropdown-item href={'#/approve-task/edit/' + item.id}>Show</b-dropdown-item>
              </b-dropdown>
            )
          }
        },
        {
          columnCode: 'image',
          columnName: 'Image',
          customizeColumn: true,
          value: item => {
            if (!item.image && item.image.url) return ''
            return <img class="profile-img-sm rounded-circle" style="height: 50px;width: 50px;" src={item.image.url}/>
          }
        },
        {
          columnCode: 'name',
          columnName: 'Title task',
          align: 'left',
          value: item => {
            if (!item.task && item.task.title) return ''
            return item.task.title
          }
        },
        {
          columnCode: 'member',
          columnName: 'Member',
          align: 'left',
          value: item => {
            let fullName = ''
            if (item.member) {
              fullName += item.member.firstName != null ? item.member.firstName + ' ' : ' '
              fullName += item.member.lastName != null ? item.member.lastName : ''
            }
            return fullName
          }
        },
        {
          columnCode: 'coin',
          columnName: 'Coin',
          align: 'left',
          value: item => {
            return item.totalCoin || 0
          }
        },
        {
          columnCode: 'date',
          columnName: 'Date',
          align: 'left',
          value: item => {
            return item.date ? moment(item.date).format('YYYY-MM-DD HH:mm') : ''
          }
        },
        {
          columnCode: 'status',
          columnName: 'Status',
          align: 'left',
          value: item => {
            return item.status === 'COMPLETED' ? 'Completed' : item.status === 'REJECTED' ? 'Rejected' : item.status === 'WAITING' ? 'Waiting' : item.status
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      return this.axios.get('daily-task-member/approve-list', payload)
    },
    addNewButton () {
    }
  },
  components: {
    ListingComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/approveTask/ApproveTaskListPage.vue